module.exports = __webpack_public_path__ + "./fonts/FraktionMono-Bold.otf";